import { trackingIntegrationListQuerySchema, type TrackingIntegration } from '@chukua/common';
import { useEffect, useState } from 'react';
import { ApiError } from '../../../../../shared/shared.api';
import { listIntegrations } from '../gps.api';

export type GpsIntegrationsState =
  { status: 'loading' } | { status: 'loaded'; integrations: TrackingIntegration[] } | { status: 'forbidden' } | { status: 'error' };

/** A deployment holds a handful of GPS accounts, so the Integrations page lists the first 100 (the API's page cap) installed, enabled or not. */
const INSTALLED_QUERY = trackingIntegrationListQuerySchema.parse({ pageSize: 100 });

export function useGpsIntegrations(): GpsIntegrationsState {
  const [state, setState] = useState<GpsIntegrationsState>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;
    listIntegrations(INSTALLED_QUERY)
      .then((page) => !cancelled && setState({ status: 'loaded', integrations: page.items }))
      .catch((err) => !cancelled && setState({ status: err instanceof ApiError && err.status === 403 ? 'forbidden' : 'error' }));
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
